export default "__VITE_ASSET__DvUI2eCa__"